import 'vue-multiselect/dist/vue-multiselect.min.css';
import cloneObject from "@/libs/cloneObject";
import ICompatibilityScore from "@/interfaces/astrology/compatibility/ICompatibilityScore";
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import Multiselect from 'vue-multiselect';
import {TRANSLATIONS} from "@/constants";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
    name: 'CompatibilityScoreForm',
    components: {
        Multiselect,
    }
})
export default class CompatibilityScoreForm extends Vue {
    @Prop(Object) private formData!: ICompatibilityScore;
    @Prop(Array) private zodiacSigns!: IMultiSelectItem[];
    @Prop(Boolean) private loading!: boolean;

    private activeTabIndex: number = 0;

    private get getLanguages() {
        return TRANSLATIONS;
    }

    // Begin Handler by Form

    private invalidValue(fieldName: string) {
        return this.$validator.errors.has(fieldName);
    }

    private transformData() {
        const readyData = cloneObject(this.formData);
        readyData.zodiacSign1 = Number(readyData.zodiacSign1.value);
        readyData.zodiacSign2 = Number(readyData.zodiacSign2.value);

        return readyData;
    }


    private validateForm() {
        this.$validator.validateAll().then((result) => {
            if (result) {
                this.$emit('saveForm', this.transformData());
            }
        });
    }

    private handleSave() {
        this.validateForm();
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private generateName(field: string) {
        return `${field}`;
    }

    private hideFields(field: string): boolean {
        const fields = [
            'id',
        ];

        return fields.includes(field);
    }
    // End Handler by Form


    @Watch('formData')
    private defaultTab() {
        this.activeTabIndex = 0;
    }
}
